import React, { useState } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { Brand } from "@/components/shared/Common";
import { useAuth } from "@/lib/auth.jsx";
import { LayoutDashboard, Sparkles, CalendarDays, FolderHeart, MessagesSquare, LogOut, Menu, X } from "lucide-react";

const NAV = [
  { to: "/patient/dashboard", label: "Dashboard", testid: "sidebar-dashboard", icon: <LayoutDashboard size={16}/> },
  { to: "/patient/intake", label: "Find Care (AI)", testid: "sidebar-intake", icon: <Sparkles size={16}/> },
  { to: "/patient/appointments", label: "Appointments", testid: "sidebar-appointments", icon: <CalendarDays size={16}/> },
  { to: "/patient/care-passport", label: "Care Passport", testid: "sidebar-care-passport", icon: <FolderHeart size={16}/> },
  { to: "/patient/messages", label: "Messages", testid: "sidebar-messages", icon: <MessagesSquare size={16}/> },
];

export default function PatientLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  React.useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-[#f5f7fa] flex">
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-white border-r border-[#e2e8f0] flex flex-col transform transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 border-b border-[#e2e8f0] flex items-center justify-between">
          <Link to="/"><Brand /></Link>
          <button className="lg:hidden" onClick={() => setOpen(false)}><X size={20}/></button>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} data-testid={n.testid}
              className={({isActive}) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium ${isActive ? "bg-[#ebf3fc] text-[#1a2b4a]" : "text-[#475569] hover:bg-[#f5f7fa] hover:text-[#1a2b4a]"}`}>
              {n.icon}{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#e2e8f0]">
          <div className="text-xs text-[#94a3b8]">Signed in as</div>
          <div className="text-sm font-medium text-[#1a2b4a] truncate" data-testid="sidebar-user-email">{user?.email}</div>
          <button onClick={logout} className="mt-3 cm-btn-outline w-full" data-testid="sidebar-logout"><LogOut size={16}/>Sign out</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="lg:hidden sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-[#e2e8f0] px-4 py-3 flex items-center justify-between">
          <button onClick={() => setOpen(true)} data-testid="patient-mobile-menu"><Menu size={22}/></button>
          <Brand />
          <div className="w-6" />
        </div>
        <main className="p-4 sm:p-6 lg:p-10 flex-1"><Outlet /></main>
      </div>
    </div>
  );
}
